import React, { useState, useEffect } from 'react'; 

import { handleResponse } from '../../../../_helpers/handle-response';
import { DropdownDataService } from '../../../../_services/dropdownData.service';
import CONSTANTS from '../../../../_constants/constants';
import { parseFloat2Decimal, parseFloat2DecimalHeader } from '../../../../_helpers/utils';
import classes from './SupplierWiseCurrencyPage.module.css';

import Alert from '../../../UI/Alert/Alert';
import Button from '../../../UI/Button/Button';
import Loader from '../../../UI/Loader/Loader';
import Table from '../../../UI/Table/Table';
import ExportToCSV from '../../../UI/ExportToCSV/ExportToCSV';
import PageLayout from '../../../Layout/PageLayout/PageLayout';

const SupplierWiseCurrencyPage = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [fromDate, setFromDate] = useState(new Date().toISOString().slice(0,10));
    const [toDate, setToDate] = useState(new Date().toISOString().slice(0,10));
    const [supplierId, setSupplierId] = useState('');
    const [supplierData, setSupplierData] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [totalData, setTotalData] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [exportFileName, setExportFileName] = useState('');
    const [enableExport, setEnableExport] = useState(false);
    const [exportTotalData, setExportTotalData] = useState({});

    const tableHeaders = ['Supplier', 'Opening Stock', 'Received', 'Total Stock', 'Sales', 'Incentive', 'Difference(+/-)', 'Closing Stock'];
    const dataFields = ['supplierName', 'openingStock', 'purchase', 'totalStock', 'sales', 'incentive', 'difference', 'closingStock'];
    const csvHeaders = [
        { label: 'Supplier', key: 'supplierName' },
        { label: 'Opening Stock', key: 'openingStock' },
        { label: 'Received', key: 'purchase' },
        { label: 'Total Stock', key: 'totalStock' },
        { label: 'Sales', key: 'sales' },
        { label: 'Incentive', key: 'incentive' },
        { label: 'Difference(+/-)', key: 'difference' },
        { label: 'Closing Stock', key: 'closingStock' }
    ];
    const tableConfig = {
        headerAlignConfig: {
            'Supplier': 'left',
            'Opening Stock': 'center',
            'Received': 'center',
            'Total Stock': 'center',
            'Sales': 'center', 
            'Incentive': 'center',
            'Difference(+/-)': 'center',
            'Closing Stock': 'center'
        },
        widthConfig: {
            'Supplier': 'auto',
            'Opening Stock': '122px',
            'Received': '122px',
            'Total Stock': '122px',
            'Sales': '122px', 
            'Incentive': '122px',
            'Difference(+/-)': '122px',
            'Closing Stock': '122px'
        },
        alignConfig: {
            'supplierName': 'left',
            'openingStock': 'right',
            'purchase': 'right',
            'totalStock': 'right',
            'sales': 'right',
            'incentive': 'right',
            'difference': 'right',
            'closingStock': 'right'
        }
    };
    useEffect(() => {
        getSupplierList();
    }, []);

    useEffect(() => {
        setErrorMessage(null);
        setEnableExport(false);
    }, [fromDate, toDate, supplierId]);
    
    const getSupplierList = () => {
        DropdownDataService.getSupplierList('filter').then( result => {
            if(result.data) {
                setSupplierId(result.data.results[0].supplierId);
                setSupplierData(result.data.results);
            } else {
                setErrorMessage(result);
            }
        });
    }

    const getReportData = () => {
        const requestOptions = {
            headers: { 
                'Token': localStorage.getItem('accessToken'),
                'Content-Type': 'application/json'
            },
        };
        let url = '';
        url = supplierId === '-1' ?
                `${CONSTANTS.API_URL}Reports/SupplierwiseCurrencyReport?startDate=${fromDate}&endDate=${toDate}` :
                `${CONSTANTS.API_URL}Reports/SupplierwiseCurrencyReport?startDate=${fromDate}&endDate=${toDate}&supplierId=${supplierId}`;
        fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            (result) => {
                if(result.data) {
                    setIsLoading(false);
                    const keysToParse = ['openingStock', 'purchase', 'totalStock', 'sales', 'incentive', 'difference', 'closingStock'];
                    parseFloat2Decimal(result.data.results, keysToParse);
                    setGridData(result.data.results);
                    setPageCount(Math.ceil(result.data.results.length/10));
                    let total = result.data.header;
                    const headerKeysToParse = ['openingStock', 'purchase', 'totalStock', 'sales', 'incentive', 'difference', 'closingStcok'];
                    parseFloat2DecimalHeader(total, headerKeysToParse);
                    setTotalData([
                        total.openingStock,
                        total.purchase,
                        total.totalStock,
                        total.sales,
                        total.incentive,
                        total.difference,
                        total.closingStcok
                    ]);
                    setExportTotalData({
                        supplierName: 'Total',
                        openingStock: total.openingStock,
                        purchase: total.purchase,
                        totalStock: total.totalStock,
                        sales: total.sales,
                        incentive: total.incentive,
                        difference: total.difference,
                        closingStock: total.closingStcok
                    });
                    setEnableExport(result.data.results.length > 0 ? true : false);
                } else {
                    setIsLoading(false);
                    setErrorMessage(result.error.message);
                }
            },
            error => {
                setIsLoading(false);
                setErrorMessage(error);
            }
        );
    }

    const showClickHandler = () => {
        setIsLoading(true);
        getReportData();
    }

    const rowClickHandler = rowData => {
        let detailedPage = window.open('/pavathi/supplier-operator-currency');
        detailedPage.startDate = fromDate;
        detailedPage.endDate = toDate;
        detailedPage.supplierId = rowData.supplierId;
        detailedPage.supplierName = rowData.supplierName;
    }

    const fromDateChangeHandler = event => setFromDate(event.target.value)
    
    const toDateChangeHandler = event => setToDate(event.target.value)

    const supplierChangeHandler = event => setSupplierId(event.target.value)

    const getExportFileName = () => {
        let exportFilename = 'SupplierWiseCurrency';
        exportFilename += '_' + fromDate;
        exportFilename += '_' + toDate;
        exportFilename += supplierId !== '-1' ? '_' + supplierData.find(data => data.supplierId == supplierId)['supplierName'] : '';
        setExportFileName(exportFilename);
    }

    return (
        <>
            { isLoading && <Loader />}
            { !isLoading && (
                <PageLayout pageTitle='Supplier Wise Currency'>
                    <div className='row mb-1'>
                        <div className='col-12' style={{display: 'flex', justifyContent:'space-between', marginTop: '6px', marginBottom: '6px'}}>
                            <form className='form-inline'>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>From Date : </label>
                                    <input type='date' onKeyDown={(e) => e.preventDefault()} required className='form-control inputField' value={fromDate} onChange={fromDateChangeHandler} />
                                </div>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>To Date : </label>
                                    <input type='date' onKeyDown={(e) => e.preventDefault()} required className='form-control inputField' value={toDate} onChange={toDateChangeHandler} />
                                </div>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>Supplier : </label>
                                    <select className='form-select customSelect' value={supplierId} aria-label=".form-select-sm example" onChange={supplierChangeHandler}>
                                        { supplierData.map( (value, index) => {
                                            return <option key={`supplier-${index}`} className='dropdownItem' value={value.supplierId}>{value.supplierName}</option>
                                        }) }
                                    </select>
                                </div>
                            </form>
                            <div>
                                <Button btnClass='btn btn-primary mr-8' onClick={showClickHandler} btnText='Show' />
                                <ExportToCSV 
                                    headers={csvHeaders}
                                    exportTotalData={exportTotalData}
                                    gridData={gridData}
                                    exportFileName={exportFileName} 
                                    exportClickHandler={getExportFileName} 
                                    enableExport={enableExport}
                                />
                            </div>
                        </div>
                    </div>
                    { errorMessage && <Alert alertClassName='danger' message={errorMessage} /> }
                    <Table 
                        tableHeaders={tableHeaders} 
                        dataFields={dataFields} 
                        tableConfig={tableConfig}
                        pageCount={pageCount} 
                        sort={false}
                        actions={true} 
                        view={true}
                        paginate={true}
                        filter={false}
                        gridData={gridData}
                        totalData={totalData}
                        onRowClick={rowClickHandler}
                    />
                </PageLayout>
            )}    
        </>
    );
  
}

export default SupplierWiseCurrencyPage;